import styled, { css } from 'styled-components';
import { BackgroundVariant } from 'core/flow/entities';

const variantStyles = {
  light: css`
    background: ${({ theme }) => theme.colors.white};
  `,
  dark: css`
    background: ${({ theme }) => theme.colors.black};
  `,
  semiLight: css`
    background: ${({ theme }) => theme.colors.themeBackgroundSemiLight};
  `,
  darkGradient: css`
    /*! @noflip */
    background: ${({ theme }) => theme.gradients.primary};
  `,
  veil: css`
    background: rgb(255, 255, 255, 0.5);
    backdrop-filter: blur(4px);
  `,
  veilGradient: css`
    /*! @noflip */
    background: linear-gradient(180deg, transparent 44%, ${({ theme }) => theme.colors.white} 100%);

    &::after {
      position: absolute;
      inset: 0;
      -webkit-mask-image: linear-gradient(180deg, transparent 44%, black 100%);
      mask-image: linear-gradient(180deg, transparent 44%, black 100%);
      content: '';
      backdrop-filter: blur(4px);
    }
  `,
};

export const AbsoluteBackgroundContainer = styled.div<{ variant: BackgroundVariant }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;

  ${({ variant }) => variantStyles[variant]}
`;
